import { MultiSelect } from "primereact/multiselect";
import { useTransactionStepContext } from "../transaction-step.context";
import "./transaction-children.scss";
import { useCallback, useEffect } from "react";
import ChildInfo from "@core/ui/child-info/child-info";
import { useNewTransactionContext } from "../new-transaction.context";
import FormMemberWrapper from "@domain/member/form-member-wrapper/form-member-wrapper";
import { Button } from "primereact/button";

/* eslint-disable-next-line */
export interface TransactionChildrenProps {}

export function TransactionChildren() {
  const {
    childrenList,
    selectedChildren,
    childFormCount,
    childFormRefs,
    childFormData,
    setSelectedChildren,
    handleChildFormSubmit,
    previousStepper,
    handleChildTrigger,
    nextStepper,
    handleAddChildForm,
  } = useTransactionStepContext();
  const {
    addNewChild,
    isCreating,
    isCreateNewParent,
    setAddNewChild,
    createChildren,
  } = useNewTransactionContext();

  useEffect(() => {
    (async () => {
      if (childFormData.length > 0) {
        const newChildren = await createChildren();
        const childrenIds = newChildren.map((item) => item.value);
        setSelectedChildren((children) => [...children, ...childrenIds]);
        nextStepper();
      }
    })();
  }, [childFormData]);

  const displaySelectedChildren = useCallback(() => {
    const childrenData = selectedChildren.map((item) =>
      childrenList.find((x) => x.value === item)
    );

    if (childrenData.length === 0) return null;

    return childrenData.map((item, id) => (
      <ChildInfo
        key={id}
        birthday={item?.payload?.birthday}
        name={item?.label || ""}
        photo={item?.payload?.fileBlob}
      />
    ));
  }, [selectedChildren]);

  const handleChildrenNext = () => {
    handleChildTrigger();

    if (selectedChildren.length > 0) {
      nextStepper();
    }
  };
  const handleAddChild = () => {
    setAddNewChild(true);
  };
  const handleAddAnotherChild = () => {
    setAddNewChild(true);
    handleAddChildForm();
  };

  // RENDER
  const childrenForm = (
    <section className="grid grid-cols-1 gap-2 mb-4">
      {childrenList.length > 0 ? (
        <div>
          <small className="block">Select multiple children</small>
          <MultiSelect
            value={selectedChildren}
            onChange={(e) => setSelectedChildren(e.value)}
            options={childrenList}
            placeholder="Select children"
            className="w-full md:w-1/2"
          />
        </div>
      ) : null}

      {displaySelectedChildren() ? (
        <section>
          <small className="block">Selected Children</small>
          <div className="flex flex-wrap gap-2">
            {displaySelectedChildren()}
          </div>
        </section>
      ) : null}

      <div className="flex flex-wrap gap-2">
        {addNewChild
          ? Array.from({ length: childFormCount }, (_, index) => (
              <div className="border-2 border-dashed p-4" key={index}>
                <FormMemberWrapper
                  ref={(el) => {
                    childFormRefs.current[index] = el!;
                  }}
                  isChild={true}
                  onSubmit={(data) => handleChildFormSubmit(data, index)}
                />
              </div>
            ))
          : null}
      </div>
    </section>
  );

  return (
    <div id="TransactionChildren" className="transaction-children">
      <div className="flex flex-col flex-wrap gap-4">
        {isCreating && isCreateNewParent ? (
          <div>Loading Please wait...</div>
        ) : (
          childrenForm
        )}
      </div>
      <div className="flex pt-4 justify-between">
        <section className="flex gap-2">
          <Button
            label="Back"
            severity="success"
            outlined
            icon="pi pi-arrow-left"
            onClick={() => previousStepper()}
          />
          {!addNewChild ? (
            <Button
              label="Add Child"
              icon="pi pi-plus"
              iconPos="right"
              outlined
              onClick={handleAddChild}
            />
          ) : (
            <Button
              label="Add Another Child"
              icon="pi pi-plus"
              iconPos="right"
              outlined
              onClick={handleAddAnotherChild}
            />
          )}
        </section>
        <Button
          label="Next"
          icon="pi pi-arrow-right"
          iconPos="right"
          disabled={isCreating}
          onClick={handleChildrenNext}
        />
      </div>
    </div>
  );
}

export default TransactionChildren;
